// Return true if there is already a '-' or '.' else return false

export function DuplicateMinusOrComma(
  key: string,
  previousValue: string
): boolean {
  if (
    previousValue === null ||
    previousValue === undefined ||
    previousValue === ''
  ) {
    return false;
  }

  if (key === '-') {
    return previousValue.includes('-');
  }

  if (key === '.') {
    return previousValue.includes('.');
  }
  return false;
}
